import SortPartyGroupsByDate from "../../SortPartyGroupsByDate";
import { PartyModel } from "../../types";
import { ApiResponse } from "../../api/responses/AxiosResponseHandler";

interface UpdateJoinVipVisibilityAndRefreshArgs {
  groupId: string;
  updateJoinVipVisibility: (groupId: string) => Promise<ApiResponse<void> | undefined>;
  getParsedMyPartyById: (groupId: string) => Promise<ApiResponse<PartyModel> | undefined>;
  setSelectedPartyContextData: (party: PartyModel | null) => void;
  setMyPartiesInfoContextData: (updater: (previousParties: PartyModel[]) => PartyModel[]) => void;
}

export async function updateJoinVipVisibilityAndRefresh({
  groupId,
  updateJoinVipVisibility,
  getParsedMyPartyById,
  setSelectedPartyContextData,
  setMyPartiesInfoContextData,
}: UpdateJoinVipVisibilityAndRefreshArgs): Promise<PartyModel> {
  const response = await updateJoinVipVisibility(groupId);

  if (!response || response.statusCode >= 400) {
    throw new Error("Failed to update group visibility.");
  }

  const refreshedParty = (await getParsedMyPartyById(groupId))?.data ?? null;

  if (!refreshedParty) {
    throw new Error("Failed to refresh selected party.");
  }

  setSelectedPartyContextData(refreshedParty);
  setMyPartiesInfoContextData((previousParties) =>
    SortPartyGroupsByDate(
      previousParties.some((currentParty) => currentParty.party.id === refreshedParty.party.id)
        ? previousParties.map((currentParty) =>
            currentParty.party.id === refreshedParty.party.id ? refreshedParty : currentParty
          )
        : [...previousParties, refreshedParty]
    )
  );

  return refreshedParty;
}
